<template lang="pug">
.child-avatar
  btn-delete(v-if="child!==null" @delete="onRemove")
  //.delete(v-if="child!==null" @click="onRemove")
    img(src="~assets/btn-close.png")
  .avatar
    .placeholder(v-if="child===null" @click="onClick")
      icon-plus
    .child(v-if="child!==null" @click="onCheck")
      img(src="~assets/avatar-default.png")
      child-icon

  .instruction {{child? child.nickname : $t('famPicker.addChild')}}
  .warning(v-if="child && child.vspFaceStatus !== 1") 人脸未核验
</template>
<script>
import IconPlus from '@/components/res/IconPlus'
import ChildIcon from '@/components/wedgits/ChildIcon'
import { mapActions, mapMutations, mapState } from 'vuex'
import BtnDelete from '@/components/wedgits/BtnDelete'
export default {
  name: 'ChildAvatar',
  components: { BtnDelete, ChildIcon, IconPlus },
  props: {
    child: {},
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
  },
  methods: {
    ...mapActions('app', ['RemoveSubUser', 'GetUser']),
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    onRemove() {
      let payload = {
        userId: this.getMasterId(),
        subUserId: this.child.id,
      }
      //console.log(this.getMasterId())
      this.setPending(true)
      this.RemoveSubUser(payload).then((res) => {
        console.log(res)
        this.GetUser(this.user.id).then((res) => {
          this.setPending(false)
        })
      })
    },

    getMasterId() {
      for (let user of this.user.famUsers) {
        if (user.type === 1) return user.id
      }
    },
    onClick() {
      this.$emit('clicked')
    },
    onCheck() {
      if (this.child.vspFaceStatus !== 1) {
        this.$emit('verify', this.child.id)
      }
    },
  },
  mounted() {
    console.log('CHCHCHCHCCH', this.child)
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.child-avatar
  width: 100%
  position: relative

  .avatar
    width: pxToRem(180)
    height: pxToRem(180)
    box-shadow: pxToRem(-10) pxToRem(-10) pxToRem(17) 0 rgba(255,255,255,0.02), pxToRem(-19) pxToRem(-10) pxToRem(23) 0 rgba(252,252,252,0.74), pxToRem(-12) pxToRem(8) pxToRem(17) 0 rgba(252,252,252,0.35), pxToRem(2) pxToRem(13) pxToRem(43) 0 rgba(228,228,228,0.80)
    border-radius: pxToRem(90)
    background: #ffffff
    display: flex
    justify-content: center
    align-items: center
    border: white pxToRem(10) solid
    .placeholder
      width: pxToRem(36)
      height: pxToRem(36)
      line-height: 0
    .child
      //width: 60%
      //height: 60%
      width: 100%
      height: 100%
      img
        width: 100%
        object-fit: contain
      .child-icon
        width: pxToRem(56)
        height: pxToRem(56)
        position: absolute
        top: pxToRem(130)
        right: pxToRem(5)
  .instruction
    font-size: pxToRem(30)
    text-align: center
    margin-top: pxToRem(20)
  .warning
    font-size: pxToRem(30)
    text-align: center
    margin-top: pxToRem(-5)
    color: #e15125
</style>
